import { lazy, Suspense } from "react";
import { Redirect, Switch, Route, useLocation } from "react-router-dom";
import Footer from "../components/Footer";
import Header from "../components/Header";
import routes from "./config";
import { Styles } from "../styles/styles";
import Company from "../pages/Companies/Company";
import Admin from "../pages/Companies/Admin";
import AddAdmin from "../pages/Admin/Add-Admin";
import PrivateRoute from "./PrivateRoute";
import CompanyList from "../pages/Companies/CompanyList";
import CompanyHeader from "../components/CompanyHeader";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet-async";

const legacyRedirects = [
  ["/enterprise-ai-iraq", "/services/ai-solutions"],
  ["/ai-company-iraq", "/services/ai-solutions"],
  ["/artificial-intelligence-iraq", "/services/ai-solutions"],
  ["/ai-solutions-iraq", "/services/ai-solutions"],
  ["/business-ai-iraq", "/services/ai-solutions"],
  ["/document-ai", "/services/document-ai"],
  ["/rag", "/services/ai-assistant"],
  ["/fine-tuning", "/services/ai-solutions"],
  ["/ai-agents", "/services/ai-agents"],
  ["/computer-vision", "/services/computer-vision"],
] as const;

const Router = () => {
  const location = useLocation();
  const isCompanyPage = location.pathname.startsWith("/company/");
  const { i18n } = useTranslation();
  const isArabic = i18n.language?.startsWith("ar");
  const isPrivateUtility = [
    "/admin-login",
    "/add-admin",
    "/company-list",
    "/companies/admin",
  ].includes(location.pathname);

  // Set direction and language for the document
  document.documentElement.lang = isArabic ? "ar" : "en";
  document.documentElement.dir = isArabic ? "rtl" : "ltr";

  return (
    <Suspense
      fallback={
        <div
          aria-busy="true"
          aria-label={
            isArabic ? "جاري التحميل..." : "Loading..."
          }>
          {isArabic ? "جاري التحميل..." : "Loading..."}
        </div>
      }>
      <Styles />
      {isPrivateUtility && (
        <Helmet>
          <meta name="robots" content="noindex, nofollow, noarchive" />
        </Helmet>
      )}
      {/* Header: Only render one header per page */}
      {isCompanyPage ? <CompanyHeader /> : <Header />}
      <main tabIndex={-1} id="main-content">
        <Switch>
          <Redirect from="/home" exact to="/" />
          <Redirect from="/home/" exact to="/" />
          {legacyRedirects.map(([from, to]) => (
            <Redirect key={from} from={from} exact to={to} />
          ))}
          <Route path="/company/:id" exact component={Company} />
          <Route path="/company/:ids+" exact component={Company} />
          <PrivateRoute path="/companies/admin" exact component={Admin} />
          <Route path="/add-admin" exact component={AddAdmin} />
          <PrivateRoute path="/company-list" exact component={CompanyList} />
          {routes.map((routeItem) => (
            <Route
              key={`${routeItem.component}-${Array.isArray(routeItem.path) ? routeItem.path.join("-") : routeItem.path}`}
              path={routeItem.path}
              exact={routeItem.exact}
              component={lazy(() => import(`../pages/${routeItem.component}`))}
            />
          ))}
          <Redirect to="/404" />
        </Switch>
      </main>
      <Footer />
    </Suspense>
  );
};

export default Router;
